module.exports = __webpack_public_path__ + "img/device_1014_1_select.80767402.svg";